import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "HOFMP")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = { class: "d-flex flex-stack mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5",
  tabindex: "3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off",
            tabindex: "1"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("a", {
              href: "javascript:void(0)",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'reset-password' })))
            }, "Forgot Password")
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid password",
            type: "password",
            name: "password",
            autocomplete: "off",
            tabindex: "2",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, _hoisted_16, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}